import React from 'react'
// import { withLocalize } from 'react-localize-redux'
import Style from 'style-it'
// import Loader from '../../Loader'
import InvoiceFilter from '../../../Components/common/WorkFlowFilter'
import { useSelector } from 'react-redux'
const WorkFlow=(props)=>{
  const geoFence=useSelector((state)=>state.geoFence)
  const themecolors=useSelector((state)=>state.themeColors)
  const submitSideBarSearch = (e)=>{
    props.fetchData('userId',1,50,false,true,e)
  }
    // const { workFlows } = this.props
    return (
      <Style>
        {`.material-icons {vertical-align: middle; color: inherit}`}
        <div className='fms-sidebar sidebar-bg-layer'>
        <div style={{ padding: 13 }}>
       <h3
          style={{ display: 'flex', alignItems: 'center', margin: 0 }}
        >
          <span>{props.translate('workFlows')}</span>
          </h3>
        </div>
        {
            <InvoiceFilter
              {...props}
              geoFence={geoFence}
              themecolors={themecolors}
              formSubmit={submitSideBarSearch}
              sidebar
              invoice
              loader={props.loader}
            />
        }
        </div>
      </Style>
    )
}

export default WorkFlow

